import {
  ChatbotConversationDynamicFilterField,
  ChatbotConversationDynamicFilterItem,
  ChatbotConversationSortField,
  DynamicFilterItemOperation,
  DynamicFilterOperator,
  HealthDataReportStateKind,
  SortDirection,
} from '@src/types.ts'

export const CONVERSATIONS_PAGE_SIZE = 20

export const HOME_CONVERSATIONS_PREVIEW_LIMIT = 4

export const CONVERSATIONS_SORTS = [
  {
    direction: SortDirection.Desc,
    field: ChatbotConversationSortField.CreatedAt,
  },
]

export const PINNED_CONVERSATIONS_FILTER: ChatbotConversationDynamicFilterItem[] = [
  {
    operator: DynamicFilterOperator.And,
    items: [
      {
        field: ChatbotConversationDynamicFilterField.Pinned,
        operation: DynamicFilterItemOperation.Eq,
        value: 'true',
      },
    ],
  },
]

export const CONVERSATIONS_LOADING_ERROR = 'Failed to load conversations, please try again.'
export const CONVERSATION_UPDATE_ERROR = 'Failed to update conversation, please try again.'
export const PROMPTS_LOADING_ERROR = 'Failed to load quick prompts, please try again.'
export const CHANNEL_ERROR = 'Failed to open conversation, please try again.'

export enum HistoryView {
  ALL = 'all',
  PINNED = 'pinned',
  REPORTS = 'reports',
  QUICK_PROMPTS = 'quick_prompts',
}

export enum NoraVoiceModeSource {
  ChatInputToggle = 'chat_input_toggle',
  HomeActionButtonLongPress = 'home_action_button_long_press',
  HomeVoiceCard = 'home_voice_card',
}

export const POLLING_REPORT_STATES = [
  HealthDataReportStateKind.Created,
  HealthDataReportStateKind.DataFetched,
]
